module.exports = Object.freeze({
  scheduled: 'scheduled',
  received: 'received',
  canceled: 'canceled'
});
